import { AgInput, type AgInputProps } from 'src/components/ui';
import useSystemUnitRounding from 'src/hooks/useSystemUnitRounding';
import { useEditStateDebounce } from 'src/providers/EditingStateProvider';
import capNumberToDecimal from 'src/utils/capNumberToDecimal';

const ROUNDING_DELAY = 500;

const InventoryQuantityTextField = ({
  value,
  onChange,
  handleUpdate,
  ...props
}: Omit<AgInputProps, 'onChange'> & {
  onChange?: (value: string) => void;
  /** Use handleUpdate when the request is sent on value change; otherwise onChange and the debounced rounding each fire a request. */
  handleUpdate?: (value: string) => void;
}) => {
  const unitRounding = useSystemUnitRounding();

  const handleRoundedChange = useEditStateDebounce((inputValue: string) => {
    const parsed = parseFloat(inputValue);
    const trimmedValue = +parsed.toFixed(2);
    const roundedValue = unitRounding(trimmedValue).toString();

    const updateFunc = handleUpdate ?? onChange;
    updateFunc?.(roundedValue);
  }, ROUNDING_DELAY);

  const handleChange = (inputValue: string) => {
    const cappedValue = capNumberToDecimal(inputValue);
    onChange?.(cappedValue);
    handleRoundedChange(cappedValue);
  };

  return <AgInput {...props} value={value?.toString()} onChange={handleChange} />;
};

export default InventoryQuantityTextField;
